import { Box, useBoolean } from '@stenajs-webui/core';
import type { TextInputButtonSize } from '@stenajs-webui/elements';
import type { FC, ReactNode } from 'react';
import { InformationMessageIcon } from '../../common-ui/information-message/InformationMessageIcon';
import { InformationMessageType } from '../../common-ui/information-message/informationMessageUtils';
import { FreightPortalControlledPopover } from '../../common-ui/popover/FreightPortalControlledPopover';
import { PopoverBody } from '../../common-ui/popover/PopoverBody';
import { PopoverTitle } from '../../common-ui/popover/PopoverTitle';

interface RowInformationCellPopupProps {
  children?: ReactNode;
  initialOpen?: boolean;
  maxWidth?: number;
  minWidth?: number;
  size?: TextInputButtonSize;
  title: string;
  type?: InformationMessageType;
}

export const RowInformationCellPopup: FC<RowInformationCellPopupProps> = ({
  children,
  type = InformationMessageType.RegularInfo,
  size,
  initialOpen = false,
  minWidth = 240,
  maxWidth = 315,
  title,
}) => {
  const [isOpen, open, close] = useBoolean(initialOpen);

  return (
    <FreightPortalControlledPopover
      renderTrigger={props => (
        <InformationMessageIcon size={size} type={type} onClick={open} {...props} />
      )}
      onRequestClose={close}
      open={isOpen}
      placement={'right-start'}
    >
      <Box minWidth={minWidth} maxWidth={maxWidth} className={'t_information_popup'}>
        <PopoverTitle text={title} onClose={close} />
        <PopoverBody>{children}</PopoverBody>
      </Box>
    </FreightPortalControlledPopover>
  );
};
